import axios from 'axios';

//const API_BASE_URL = 'http://localhost:8000/api/v1';
const API_BASE_URL= 'https://wms.galenium.com/api/v1';

const reportService = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

reportService.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    //console.log("Axios Interceptor - Current Token:", token);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const reconciliationService = {
    // Get all warehouses
    getWarehouses: () => reportService.get('/warehouses'),

    // Get warehouse statistics
    getWarehouseStats: () => reportService.get('/warehouse-stats'),

    // Get reconciliation report with filters
    getReconciliationReport: (params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.warehouse_id) queryParams.append('warehouse_id', params.warehouse_id);
        if (params.search) queryParams.append('search', params.search);
        if (params.start_date) queryParams.append('start_date', params.start_date);
        if (params.end_date) queryParams.append('end_date', params.end_date);

        const url = `/reconciliation${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
        return reportService.get(url);
    },

    // Get reconciliation by item with filters
    getReconciliationByItem: (itemCode, params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.warehouse_id) queryParams.append('warehouse_id', params.warehouse_id);
        if (params.start_date) queryParams.append('start_date', params.start_date);
        if (params.end_date) queryParams.append('end_date', params.end_date);

        const url = `/reconciliation/${itemCode}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
        return reportService.get(url);
    }
};

export default reportService;